import React from 'react';

import { addFAQsPropertyService } from '@mygpt/app/faqs-property/services/add';
import { batchDeleteFAQsPropertyService, deleteFAQsPropertyService } from '@mygpt/app/faqs-property/services/delete';
import { updateFAQsPropertyService } from '@mygpt/app/faqs-property/services/update';
import {
  appendFAQsPropertyStore,
  deleteFAQsPropertyStore,
  updateFAQsPropertyStore,
} from '@mygpt/app/faqs-property/store';

export const useFAQsPropertyMethods = (datasetId: string) => {
  const [loading, setLoading] = React.useState(false);

  const add = React.useCallback(
    async (params: Parameters<typeof addFAQsPropertyService>[0]) => {
      setLoading(true);
      return addFAQsPropertyService(params)
        .then((res) => {
          appendFAQsPropertyStore(datasetId, 'records', res.data);
          appendFAQsPropertyStore(datasetId, 'all', res.data);
        })
        .finally(() => {
          setLoading(false);
        });
    },
    [datasetId]
  );

  const update = React.useCallback(
    async (params: Parameters<typeof updateFAQsPropertyService>[0]) => {
      setLoading(true);
      return updateFAQsPropertyService(params)
        .then((res) => {
          updateFAQsPropertyStore(datasetId, 'records', res.data);
          updateFAQsPropertyStore(datasetId, 'all', res.data);
        })
        .finally(() => {
          setLoading(false);
        });
    },
    [datasetId]
  );

  const _delete = React.useCallback(
    async (params: Parameters<typeof deleteFAQsPropertyService>[0]) => {
      setLoading(true);
      return deleteFAQsPropertyService(params)
        .then(() => {
          deleteFAQsPropertyStore(datasetId, 'all', params.propertyId);
          deleteFAQsPropertyStore(datasetId, 'records', params.propertyId);
        })
        .finally(() => {
          setLoading(false);
        });
    },
    [datasetId]
  );

  const batchDelete = React.useCallback(
    async (params: Parameters<typeof batchDeleteFAQsPropertyService>[0]) => {
      setLoading(true);
      return batchDeleteFAQsPropertyService(params)
        .then(() => {
          params.propertyIds.forEach((id) => {
            deleteFAQsPropertyStore(datasetId, 'all', id);
            deleteFAQsPropertyStore(datasetId, 'records', id);
          });
        })
        .finally(() => {
          setLoading(false);
        });
    },
    [datasetId]
  );

  return {
    loading,
    addFAQsProperty: add,
    updateFAQsProperty: update,
    deleteFAQsProperty: _delete,
    batchDeleteFAQsProperty: batchDelete,
  };
};
